import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import Stamp from "../../models/stamp";

interface StampCrudAtionsProps {
  stamp: Stamp;
  onUpdateClick: (_: Stamp) => void;
  onDeleteClick: (_: Stamp) => void;
  isDemo?: boolean;
}

const StampCrudActions: React.FC<StampCrudAtionsProps> = ({
  stamp,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}) => {
  const editButton = (
    <CTooltip content="Editar">
      <CButton
        className="text-white"
        color="warning"
        onClick={() => {
          onUpdateClick(stamp);
        }}
      >
        <i className="fa fa-pencil"></i>
      </CButton>
    </CTooltip>
  );

  const deleteButton = (
    <CTooltip content="Eliminar">
      <CButton
        className="text-white"
        color="danger"
        onClick={() => {
          onDeleteClick(stamp);
        }}
      >
        <i className="fa fa-trash"></i>
      </CButton>
    </CTooltip>
  );

  return (
    <td className="text-center">
      <CButtonGroup>
        {!isDemo && editButton}
        {!isDemo && deleteButton}
      </CButtonGroup>
    </td>
  );
};

export default StampCrudActions;
